module.exports = __webpack_public_path__ + "img/asana-logo-grey.1ea987a1.svg";